import React from 'react'

const PolicyBalance = () => {
  return (
    <div>PolicyBalance</div>
  )
}

export default PolicyBalance